import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import BWArchive from './BWArchive';

import { lang } from '../../redux/lang/selectors';
import {
  list,
  listCount,
  loading,
} from '../../redux/business-weekly/selectors';
import { listByDoctype as categories } from '../../redux/category/selectors';
import {
  resultsComposed as searchResults,
  resultsAmount as searchResultsAmount,
  loading as searchLoading,
} from '../../redux/search/selectors';
import { getList } from '../../redux/business-weekly/actions';
import { getListByDoctypePublic as getCategories } from '../../redux/category/actions';
import { search, reset as resetSearch } from '../../redux/search/actions';

const selector = createStructuredSelector({
  list,
  listCount,
  loading,
  selectedLang: lang,
  categories,
  searchResults,
  searchResultsAmount,
  searchLoading,
});

const actions = { getList, getCategories, search, resetSearch };

export { BWArchive };

export default connect(selector, actions)(BWArchive);
